import { render, staticRenderFns } from "./scrollIndicator.vue?vue&type=template&id=92991afa"
import script from "./scrollIndicator.vue?vue&type=script&lang=js"
export * from "./scrollIndicator.vue?vue&type=script&lang=js"
import style0 from "./scrollIndicator.vue?vue&type=style&index=0&id=92991afa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports